import { Component } from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

function ErrorFallback({ error, onReset }) {
  return (
    <div className="flex items-center justify-center p-8">
      <div className="card max-w-md w-full text-center">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-danger-100 dark:bg-danger-900/30 mb-4">
          <ExclamationTriangleIcon className="w-6 h-6 text-danger-600 dark:text-danger-400" />
        </div>
        <h2 className="mb-1">Something went wrong</h2>
        <p className="text-sm text-neutral-500 dark:text-neutral-400 mb-4">
          An unexpected error occurred. Please try again.
        </p>
        {import.meta.env.DEV && error?.message && (
          <code className="block text-xs text-left bg-neutral-100 dark:bg-neutral-700 rounded-lg p-3 mb-4 text-neutral-600 dark:text-neutral-300 overflow-auto">
            {error.message}
          </code>
        )}
        <button onClick={onReset} className="btn btn-primary">
          Try again
        </button>
      </div>
    </div>
  );
}

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    if (import.meta.env.DEV) {
      console.error('[ErrorBoundary]', error, info);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorFallback
          error={this.state.error}
          onReset={() => this.setState({ hasError: false, error: null })}
        />
      );
    }
    return this.props.children;
  }
}
